import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetConfigurationCode, resetError } from '../../../../Reducers/Configurator/Actions';
import { withStyles } from '@material-ui/core/styles';
import { setVisible } from '../../../../Reducers/Ui/Actions';

import saveIcon from './icons/save.svg';

const SaveButton = withStyles({
  root: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 8px',
  },
  icon: {
    width: 32,
  },
  label: {
    fontSize: '0.9em',
  },
})(({ classes }) => {
  const { error } = useSelector((state) => state.configurator.configuration);
  const dispatch = useDispatch();

  const handleSave = async () => {
    if (error) {
      dispatch(resetError());
    }
    await dispatch(resetConfigurationCode());
    dispatch(setVisible('saveConfiguration', true));
  };
  return (
    <div className={classes.root} onClick={handleSave}>
      <img src={saveIcon} className={classes.icon} />
    </div>
  );
});

export default SaveButton;
